import { useAct } from 'DashboardUser/store'

export default function SearchField() {
  const act = useAct()
  const searchText = useSel(s => s.local.filters?.searchText || '')
  const isDirty = useSel(s => s.local.isDirty)
  const timeoutRef = useRef(null)
  const prevSearchText = useRef(searchText)

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    if (isDirty) {
      const isTextChange = searchText !== prevSearchText.current
      const delay = isTextChange ? 500 : 0
      timeoutRef.current = setTimeout(() => {
        handleSearchSubmit()
      }, delay)
    }

    prevSearchText.current = searchText

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [searchText, isDirty])
  
  function setSearchText(value) {
    act.local.setFilter('searchText', value);
  }
  
  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      handleSearchSubmit()
    }
  }
  
  function handleSearchSubmit() {
    act.app.reloadTargets()
  }
  
  return (
    <div className='search-box'>
      <svg className='search-icon' fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
      <input
        type="text"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        onKeyPress={handleSearchKeyPress}
        placeholder="Search for someone by name, email, or membership number"
      />
    </div>)
  }